import { render, staticRenderFns } from "./PostMainImage.vue?vue&type=template&id=c6b06222"
import script from "./PostMainImage.vue?vue&type=script&lang=js"
export * from "./PostMainImage.vue?vue&type=script&lang=js"
import style0 from "./PostMainImage.vue?vue&type=style&index=0&id=c6b06222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports